import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isEmptyData } from '../../utils/helper';
import { useParams } from 'react-router-dom';

const useProduct = () => {
  const { type } = useParams();
	const { keyword, data: products, loading: isLoading, selectedCategory } = useSelector((store) => store?.product);
	
  const filteredProduct = useMemo(() => {
		if (!products?.length) return [];

		let result = [];

		if (!isEmptyData(type)) {
			result = products?.filter((product) => {
				if (isEmptyData(product?.product_availability)) return false;
				return product.product_availability.some((item) => item?.label?.toLowerCase().replace(/\s+/g, '') === type?.toLowerCase().replace(/\s+/g, ''));
			});
		}

		return result;
	}, [products, type]);

  return {
		keyword,
		products: filteredProduct,
    isLoading,
    selectedCategory
	};
};

export default useProduct;
